var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"buttons-wrapper"},_vm._l((_vm.buttons),function(item){return _c('v-btn',{key:item.title,class:`button-chip elevation-0 mx-2 d-flex align-center justify-center ${
          _vm.selected !== item.id ? 'button-chip--inactive' : 'button-chip--active'
        }`,attrs:{"outlined":"","color":"pink"},on:{"click":() => {
            item.action();
            _vm.selected = item.id;
          }}},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(item.title))])])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }